const PAGE_HOME = "News Home";
const PAGE_CATEGORY = "News Category";
const PAGE_ARTICLE = "News Article";
const PAGE_AUTHOR = "News Author";
const PAGE_SEARCH_RESULTS = "News Search Results";
const PAGE_TAG_RESULTS = "News Tag Results";
const PAGE_ABOUT = "News About";
const PAGE_NOT_FOUND = "Not Found";

export {
  PAGE_HOME,
  PAGE_CATEGORY,
  PAGE_ARTICLE,
  PAGE_AUTHOR,
  PAGE_SEARCH_RESULTS,
  PAGE_TAG_RESULTS,
  PAGE_ABOUT,
  PAGE_NOT_FOUND,
};
